export const ticketShopScript = `<script src="https://web-cdn.fixr.co/scripts/fixr-shop-widget.v1.min.js" data-fixr-shop-id="4ce758fc-e900-4362-8805-7c14ca15d350" data-fixr-theme="dark"></script>`;
